import React, { Component } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import dropdownFilterCell from "../../common/grid/dropdownFilterCell";
import { Localization } from "../../common/Localization";
import { Renderers } from "../../common/GridRowRenderer";
import { provideLocalizationService } from "@progress/kendo-react-intl";
import { Button } from "@progress/kendo-react-buttons";
import { appController } from "../../../controllers/app.controller";
import dropdownSkladFilterCell from "../../common/grid/dropdownSkladFilterCell";

const levelDropdownFilterCell = dropdownFilterCell("Vyberte level...", ["INFO", "WARNING", "ERROR", "DEBUG"]);
const skladDropdownFilterCell = dropdownSkladFilterCell();

const skladCell = (props) => {
    return (
        <td>
            {props.dataItem.nazov}
        </td>
    );
};

class LogReportGrid extends Component {
    state = {
        sklady: [],
        selectedIdSklad: null,
        selectedId: null,
        skip: 0,
        take: 100
    };

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    };

    gridRowEventHandler = (eventType, dataItem) => {
        if (eventType === "onDoubleClick") {
            this.props.openLogDetail(dataItem);
        }
    };

    render() {
        var localizationService = provideLocalizationService(this);
        var renderers = new Renderers();

        return (
            <div id="Log4NetGrid">
                <h2 className="row">
                    <div className="col-xs-6">
                        <Localization messageKey={"MenuFRM.LOGY"} defaultMessage={"LOGY"} />
                    </div>
                    <div className="col-xs-6">
                        <Button icon="refresh" className="pull-right" onClick={() => this.props.refreshGrid()}>
                            <Localization messageKey={"LogReport.Grid.Aktualizovať"} defaultMessage={"Aktualizovať"} />
                        </Button>
                    </div>
                </h2>
                <Grid
                    data={this.props.items
                        .slice(this.state.skip, this.state.take + this.state.skip)
                        .map((item) => ({ ...item, selected: item.id === this.state.selectedId }))}
                    selectedField="selected"
                    skip={this.state.skip}
                    take={this.state.take}
                    total={this.props.items.length}
                    pageable={{
                        buttonCount: 10,
                        info: true,
                        type: "numeric",
                        pageSizes: [25, 50, 100],
                        previousNext: true
                    }}
                    onPageChange={this.pageChange}
                    filterable
                    filter={this.props.filter}
                    filterOperators={{
                        text: [{ text: "grid.filterContainsOperator", operator: "contains" }],
                        date: [{ text: "grid.filterEqOperator", operator: "eq" }],
                        numeric: [{ text: "grid.filterEqOperator", operator: "eq" }]
                    }}
                    onFilterChange={(e) => {
                        this.props.callSearch(e.filter);
                    }}
                    onRowClick={(e) => {
                        this.setState({ selectedId: e.dataItem.id });
                    }}
                    rowRender={(trElement, dataItem) => renderers.rowRender(trElement, dataItem, this.gridRowEventHandler)}>
                    <Column field="id" title="Id" filterable={false} width="60px" />
                    <Column
                        field="date"
                        title={localizationService.toLanguageString("LogReport.Grid.Dátum", "Dátum")}
                        width="140px"
                        filter="date"
                        format="{0:dd.MM.yyyy H:mm:ss}"
                    />
                    <Column field="thread" title="Thread" filterable={false} width="60px" />
                    <Column field="level" title="Level" width="150px" filterCell={levelDropdownFilterCell} />
                    <Column field="logger" title="Logger" />
                    <Column field="message" title="Message" />
                    <Column field="celeMeno" title={localizationService.toLanguageString("LogReport.Grid.Používateľ", "Používateľ")} width="150px" />
                    <Column field="sklad" title="Sklad / Predajňa" width="280px" cell={skladCell} filterCell={skladDropdownFilterCell} />
                </Grid>
            </div>
        );
    }
}

export default LogReportGrid;



// WEBPACK FOOTER //
// ./src/components/views/LogReport/LogReportGrid.js